import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { devtools } from 'zustand/middleware'

/**
 * Activation gate — mirrors the `activated` flag on Company (backend).
 * Operators flip the flag manually via mongo; the frontend just reads it
 * to decide whether to render the app or a "pending activation" screen.
 */
interface ActivationState {
  activated?: boolean
  loading: boolean
  setActivated: (activated: boolean | undefined) => void
  setLoading: (loading: boolean) => void
  reset: () => void
}

export const useActivationStore = create<ActivationState>()(
  immer(
    devtools(set => ({
      activated: undefined,
      loading: false,
      setActivated: (activated: boolean | undefined) => set({ activated, loading: false }),
      setLoading: (loading: boolean) => set({ loading }),
      reset: () => set({ activated: undefined, loading: false }),
    })),
  ),
)
